









































































































































































































































































































import { computed, defineComponent, PropType } from "@vue/composition-api";

import { ApiResponse } from "@/api/types";

import {
  formKeyLabelList,
  EditingOfficialData,
  formPlaceholderList,
  formDescriptionList
} from "@/helpers/official";
import { OFFICIAL_STORE_KEY } from "@/helpers/hooks/useOfficial";
import { useGlobalState } from "@/helpers/hooks/useGlobalState";

import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import InputFieldGroup from "@/components/Organisms/InputFieldGroup/index.vue";
import InputField from "@/components/Organisms/InputField/index.vue";
import InputFieldLabelEditable from "@/components/Organisms/InputField/LabelEditable/index.vue";
import FieldAddButton from "@/components/Atoms/Forms/FieldAddButton/index.vue";
import TextField from "@/components/Atoms/Forms/TextField/index.vue";
import TextArea from "@/components/Atoms/Forms/TextArea/index.vue";
import OccSelectbox from "@/components/Atoms/OccSelectbox/index.vue";
import OccSelectboxDate from "@/components/Atoms/OccSelectboxDate/index.vue";
import ImageCropper from "@/components/Organisms/ImageCropper/index.vue";

export default defineComponent({
  components: {
    OccHeading,
    InputFieldGroup,
    InputField,
    InputFieldLabelEditable,
    FieldAddButton,
    TextField,
    TextArea,
    OccSelectbox,
    OccSelectboxDate,
    ImageCropper
  },
  name: "BasicInfoForm",
  props: {
    contracts: {
      type: Array as PropType<ApiResponse.ContractInformation[]>,
      default: () => []
    }
  },
  setup(props) {
    const {
      isPendingVersion,
      isShowTopHeadImage,
      officialEditingForm,
      uncroppedOfficialImage,
      uncroppedTopHeadImage,
      onSetForm,
      resetOfficialImage,
      resetTopHeadImage,
      getOfficialErrorMessage,
      getOfficialWarnMessage,
      resetOfficialError,
      changeOrderOfficialOptionalData,
      addOfficialOptionalData,
      deleteOfficialOptionalData
    } = useGlobalState(OFFICIAL_STORE_KEY);

    const getOfficialDataUniqueId = (data: EditingOfficialData) => {
      return data.id || data.tmpId;
    };

    const selectPlaceholderText = (label: string) => {
      return `${label}を選択してください`;
    };

    const inputPlaceholderText = (label: string) => {
      return `${label}を入力してください`;
    };

    const contractSelectList = computed(() => {
      return props.contracts.map(v => {
        return {
          label: `【${v.graduate_year}年卒】${v.plan}（${v.period}）`,
          value: v.id
        };
      });
    });

    const onSetUncroppedOfficialImage = (value: string) => {
      // 既存の画像＆エラーは削除
      resetOfficialImage();
      resetOfficialError({ mainKey: "official_image" });

      uncroppedOfficialImage.value = value;
    };

    const onSetUncroppedTopHeadImage = (value: string) => {
      // 既存の画像＆エラーは削除
      resetTopHeadImage();
      resetOfficialError({ mainKey: "top_head_image" });

      uncroppedTopHeadImage.value = value;
    };

    return {
      // official.tsのヘルパー関連
      formKeyLabelList,
      formPlaceholderList,
      formDescriptionList,

      // ストア関連
      isPendingVersion,
      isShowTopHeadImage,
      officialEditingForm,
      uncroppedOfficialImage,
      uncroppedTopHeadImage,
      onSetForm,
      getOfficialErrorMessage,
      getOfficialWarnMessage,
      changeOrderOfficialOptionalData,
      addOfficialOptionalData,
      deleteOfficialOptionalData,

      // コンポーネント内定義
      getOfficialDataUniqueId,
      selectPlaceholderText,
      inputPlaceholderText,
      contractSelectList,
      onSetUncroppedOfficialImage,
      onSetUncroppedTopHeadImage
    };
  }
});
